import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"none"} }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = {
  for: "transactionHash",
  class: "form-label text-capitalize-first"
}
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-header" }
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "mb-2" }
const _hoisted_16 = { class: "mb-2" }
const _hoisted_17 = { class: "mb-2" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "mb-2" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "mb-2" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "mb-2" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_28 = { class: "col-12" }
const _hoisted_29 = { class: "alert alert-info" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 0,
  class: "fa fa-spinner fa-spin me-1"
}
const _hoisted_32 = {
  key: 1,
  class: "row mt-3"
}
const _hoisted_33 = { class: "col-12" }
const _hoisted_34 = { class: "alert alert-warning" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  key: 0,
  class: "fa fa-spinner fa-spin me-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.helper.trans('labels.search_deposits'),
    modelValue: _ctx.isVisible,
    size: "lg",
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isVisible = $event)),
    onHide: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isVisible = false))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isVisible = false)),
        class: "btn btn-secondary"
      }, _toDisplayString(_ctx.helper.trans('button.close')), 1),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.searchDeposit && _ctx.searchDeposit(...args))),
        class: "btn btn-primary",
        disabled: !_ctx.form.trx || _ctx.isLoading
      }, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("i", _hoisted_36))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.search')), 1)
      ], 8, _hoisted_35)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.helper.trans('button.close')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.transaction_hash')), 1),
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.getErrors('trx')
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.trx) = $event)),
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  type: "text",
                  id: "transactionHash",
                  placeholder: _ctx.helper.trans('labels.enter_transaction_hash'),
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.searchDeposit && _ctx.searchDeposit(...args)), ["enter"]))
                }, null, 42, _hoisted_6), [
                  [_vModelText, _ctx.form.trx]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ])
      ]),
      (_ctx.searchResult)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h6", _hoisted_11, _toDisplayString(_ctx.helper.trans('labels.search_result')), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("p", _hoisted_15, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.translations.txId) + ":", 1),
                        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.searchResult.txId), 1)
                      ]),
                      _createElementVNode("p", _hoisted_16, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.translations.walletAddress) + ":", 1),
                        _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.searchResult.walletAddress || '-'), 1)
                      ]),
                      _createElementVNode("p", _hoisted_17, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.translations.fromAddress) + ":", 1),
                        _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.searchResult.fromAddress || '-'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("p", _hoisted_19, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.translations.amount) + ":", 1),
                        _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                        (_ctx.searchResult.amount)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.searchResult.amount, 0)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_21, "-"))
                      ]),
                      _createElementVNode("p", _hoisted_22, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.translations.status) + ":", 1),
                        _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                        (_ctx.searchResult.status)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(_ctx.getStatusClass(_ctx.searchResult.status))
                            }, _toDisplayString(_ctx.helper.trans(`deposit_status.${_ctx.searchResult.status.toLowerCase()}`)), 3))
                          : (_openBlock(), _createElementBlock("span", _hoisted_23, "-"))
                      ]),
                      _createElementVNode("p", _hoisted_24, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.translations.depositId) + ":", 1),
                        _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                        (_ctx.searchResult.depositId)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.searchResult.depositId.substring(0, 8)) + "...", 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_26, "-"))
                      ])
                    ])
                  ]),
                  (_ctx.searchResult.found && !_ctx.searchResult.depositId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.helper.trans('labels.deposit_not_credited')), 1),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.creditDeposit && _ctx.creditDeposit(...args))),
                            class: "btn btn-success",
                            disabled: _ctx.isLoading
                          }, [
                            (_ctx.isLoading)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_31))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('button.credit_deposit')), 1)
                          ], 8, _hoisted_30)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.searchResult && !_ctx.searchResult.found)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.helper.trans('labels.transaction_not_found')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}